module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy.4e103520.pdf";